import UtilityInput from "../components/Generic/UtilityInput";
import React, { useState } from "react";
import ResultDisplay from "../components/MC/ResultDisplay";
import "../pages/MC.css";
import DivButton from "../components/Generic/DivButton";
import Popup from "reactjs-popup";
import ConvertTimeStamp from "../Utils/ConvertTimeStamp";

const myReq = require("../Requests.js");

const MCCalc = (props) => {
  const [inputs, setInputs] = useState({});
  const [calcs, setCalcs] = useState([]);
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState("");
  const [checks, setChecks] = useState({});
  const MCInputsArr = [
    {
      value: inputs["Timeline"],
      label: "Timeline",
      isPercent: false,
      displayLabel: "Timeline",
      desc: "How many years into the future is your goal or objective.",
    },
    {
      value: inputs["ROR"],
      label: "ROR",
      isPercent: true,
      displayLabel: "Rate Of Return",
      desc: "The expected rate of return on your money.",
    },
    {
      value: inputs["SD"],
      label: "SD",
      isPercent: true,
      displayLabel: "Standard Deviation",
      desc: "Measures the amount of risk or uncertainty in an investment. A high standard deviation means the investment is more unpredictable and could have bigger gains or losses, while a low standard deviation means the investment is more stable and less likely to have big gains or losses.",
    },
    {
      value: inputs["OriginalFundingValue"],
      label: "OriginalFundingValue",
      isPercent: false,
      displayLabel: "Original Funding Value",
      desc: "Your investment assets in today’s dollar.",
    },
    {
      value: inputs["AmountToInvestAnnually"],
      label: "AmountToInvestAnnually",
      isPercent: false,
      displayLabel: "Amount To Invest Annually",
      desc: "How much money you are contributing each year to your investments or spending each year from your investments.",
    },
    {
      value: inputs["Target"],
      label: "Target",
      isPercent: false,
      displayLabel: "Target",
      desc: "This tells us how much money you want to have in the future.",
    },
  ];
  // const [openPopop, setOpenPopup] = useState();

  // const dummyData = [
  //   { percentile: 1, amount: 100 },
  //   { percentile: 5, amount: 200 },
  //   { percentile: 25, amount: 300 },
  //   { percentile: 50, amount: 400 },
  //   { percentile: 75, amount: 500 },
  //   { percentile: 95, amount: 600 },
  //   { percentile: 99, amount: 700 },
  // ];
  const handleValue = (event) => {
    const name = event.target.id;
    let value = parseFloat(event.target.value.replaceAll(",", ""));
    // console.log(value);
    if (isNaN(value) === true) value = "";
    setInputs((values) => ({
      ...values,
      [name]: value,
    }));
  };

  function handleCheck(event) {
    const name = event.target.id;
    let value = event.target.checked;
    setChecks((values) => ({
      ...values,
      [name]: value,
    }));
  }

  function handleChange(event) {
    const name = event.target.id;
    let value = event.target.value.replaceAll(",", "");
    if (name.includes("ROR") === false && name.includes("SD") === false) {
      if (value !== "-" || name.includes("Amount") === false) {
        value = parseFloat(value);
      }
    }
    if (value !== "-") {
      if (isNaN(value) === true) value = "";
    } else if (name.includes("SD")) {
      if (isNaN(value) === true) value = "";
    }

    setInputs((values) => ({
      ...values,
      [name]: value,
    }));
    // console.log(`inputs[${name}] :>> `, inputs[name]);
  }

  function handleSubmit() {
    let ia = [
      inputs["Timeline"],
      inputs["ROR"],
      inputs["SD"],
      inputs["OriginalFundingValue"],
      inputs["AmountToInvestAnnually"],
      inputs["Target"],
    ]; //inputs array

    // console.log(inputs);
    for (let i = 0; i < ia.length; i++) {
      let e = ia[i];
      if (e === undefined || isNaN(e) === true) {
        // console.log("error", "Not a number or undefined");
        return;
      }
      if (e === 0 && i < 1) {
        // console.log("error", "cannot be zero");
        return;
      }
      e = parseFloat(e);
      // console.log(e, "e");
    }

    myReq.getMC(inputs, (data) => {
      addCalc(data);
    });
  }

  function closeModal() {
    setOpen(false);
  }

  function Load() {
    let MCObject = props.activeProfile.History[selected].MCObject;
    let newInputs = {};
    for (let i = 0; i < MCInputsArr.length; i++) {
      const selectedInput = MCInputsArr[i].label;
      const checkboxState =
        checks[selectedInput + "_checkbox"] === undefined
          ? true
          : checks[selectedInput + "_checkbox"];
      // const inputElement = inputs[selectedInput];
      let MCkey = selectedInput;
      if (checkboxState === true) {
        if (selectedInput === "AmountToInvestAnnually")
          MCkey = "Amount_To_Invest_Anually";
        if (selectedInput === "OriginalFundingValue")
          MCkey = "Original_Finding_Value";
        newInputs[selectedInput] = MCObject[MCkey];
        if (selectedInput === "SD" || selectedInput === "ROR") {
          newInputs[selectedInput] = parseFloat(MCObject[MCkey] * 100).toFixed(
            2
          );
        }
      } else {
        newInputs[selectedInput] = inputs[selectedInput];
      }
      // console.log(
      //   `MCObject[${MCkey}] :>> `,
      //   MCObject[MCkey],
      //   "selectedInput>>",
      //   selectedInput,
      //   checkboxState
      // );
    }
    // console.log("newInputs :>> ", newInputs);
    // console.log(`MCObject :>> `, MCObject);
    // console.log("checks :>> ", checks);
    setInputs(newInputs);
    closeModal();
    // console.log("MCObject :>> ", MCObject);
  }

  function clearCalc(indx) {
    const updateCalc = [...calcs];
    updateCalc.splice(indx, 1);
    setCalcs(updateCalc);
  }
  function addCalc(newCalcs) {
    const updateCalc = [...calcs, newCalcs];
    setCalcs(updateCalc);
  }

  function clear(id) {
    setInputs((values) => ({
      ...values,
      [id]: "",
    }));
  }
  function clearAll() {
    setCalcs([]);
  }
  if (props.Subscribed === false) {
    return (
      <div className="OverviewContainer">
        This feature is only available for subscribers
      </div>
    );
  }
  function clearInputs() {
    setInputs({});
  }
  return (
    <div>
      <br />
      <div className="hoverBox OverviewContainer MCBox">
        <h1>Monte Carlo Calculator</h1>
        <p>
          This calculator presents a model that is used to predict the
          probability of a variety of outcomes when the potential for random
          variables is present.
        </p>
        <div className="MCBottom">
          <div className="right MCQuestions">
            {/* <UtilityInput id="Iterations" handleValue={handleValue} /> */}
            {MCInputsArr.map((input) => {
              return (
                <UtilityInput
                  id={input.label}
                  displayLabel={input.displayLabel}
                  guidelines={input.desc}
                  handleValue={handleValue}
                  handleChange={handleChange}
                  value={input.value}
                  isPercent={input.isPercent}
                  key={input.label}
                  clear={() => {
                    clear(input.label);
                  }}
                />
              );
            })}
          </div>
          <div className="buttonArea">
            <DivButton onClick={() => setOpen(true)}>Load Inputs</DivButton>
            <DivButton onClick={clearInputs}>Clear Inputs</DivButton>
            <DivButton onClick={handleSubmit}>Run Simulation</DivButton>
            <DivButton onClick={clearAll}>Clear Simulations</DivButton>
          </div>
        </div>
        <div className="MCOutputs">
          {calcs.length === 0
            ? ""
            : calcs.map((c) => {
                return (
                  <ResultDisplay
                    MCData={c}
                    key={calcs.indexOf(c)}
                    label={calcs.indexOf(c) + 1}
                    onClick={() => {
                      clearCalc(calcs.indexOf(c));
                    }}
                  />
                );
              })}
        </div>
      </div>
      <Popup open={open} onClose={closeModal}>
        <h1>Load inputs from score</h1>
        <h2>Select score</h2>
        <div className="scoresContainer">
          {props.activeProfile.paidHistory === undefined ? (
            <></>
          ) : (
            Object.keys(props.activeProfile.paidHistory).map((score) => {
              const TS = ConvertTimeStamp(score);
              const activeSel =
                selected === undefined || selected === ""
                  ? ""
                  : ConvertTimeStamp(selected);
              return (
                <div key={TS} className="MCScores">
                  <div
                    className="selectableScore"
                    onClick={() => setSelected(score)}
                  >
                    <div>{TS}</div>
                    <div>
                      {" "}
                      {props.activeProfile.paidHistory[score].Scores.Total}
                    </div>
                  </div>
                  <div
                    className={
                      activeSel === TS ? "MCCheckBoxList" : "MCNotSelected"
                    }
                  >
                    <h4>Select inputs</h4>
                    {MCInputsArr.map((checkboxes) => {
                      return (
                        <div className="MCLineItem">
                          <div>
                            {checkboxes.label
                              .replace(/([a-z])([A-Z])/g, "$1 $2")
                              .trim()}
                          </div>
                          <input
                            key={checkboxes.label + "_checkbox"}
                            id={checkboxes.label + "_checkbox"}
                            type="checkbox"
                            onChange={(e) => {
                              handleCheck(e);
                            }}
                            defaultChecked={true}
                          />
                        </div>
                      );
                    })}
                  </div>
                </div>
              );
            })
          )}
        </div>
        <DivButton onClick={closeModal}>Cancel</DivButton>
        {selected === "" ? "" : <DivButton onClick={Load}>Load</DivButton>}
      </Popup>
      {props.Dev === true ? (
        <div>{JSON.stringify(props.activeProfile)}</div>
      ) : (
        ""
      )}
      {props.Dev ? (
        <div id="logButton">
          <button onClick={() => console.log(inputs)}>Log</button>
        </div>
      ) : (
        ""
      )}
    </div>
  );
};

export default MCCalc;
